(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["body-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING = 'ease';

    function animateOpen(details, body) {
      details.setAttribute('open', '');
      var target = body.scrollHeight + 'px';
      body.animate(
        [{ height: '0px', overflow: 'hidden' }, { height: target, overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
    }

    function animateClose(details, body) {
      var current = body.offsetHeight + 'px';
      var anim = body.animate(
        [{ height: current, overflow: 'hidden' }, { height: '0px', overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = function () {
        details.removeAttribute('open');
      };
    }

    function init(section) {
      section.querySelectorAll('.s-body-benefits__card').forEach(function (details) {
        var summary = details.querySelector('.s-body-benefits__card-summary');
        var body = details.querySelector('.s-body-benefits__card-body');
        if (!summary || !body) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.open) {
            animateClose(details, body);
          } else {
            animateOpen(details, body);
          }
        });
      });
    }

    document.querySelectorAll('.s-body-benefits').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compliance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING = 'ease';

    function animateOpen(details, body) {
      details.setAttribute('open', '');
      var target = body.scrollHeight + 'px';
      body.animate(
        [{ height: '0px', overflow: 'hidden' }, { height: target, overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
    }

    function animateClose(details, body) {
      var current = body.offsetHeight + 'px';
      var anim = body.animate(
        [{ height: current, overflow: 'hidden' }, { height: '0px', overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = function () {
        details.removeAttribute('open');
      };
    }

    function initCompliance(section) {
      var allItems = Array.from(section.querySelectorAll('.s-compliance__item'));

      allItems.forEach(function (details) {
        var summary = details.querySelector('.s-compliance__item-summary');
        var body = details.querySelector('.s-compliance__item-body');
        if (!summary || !body) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.open) {
            animateClose(details, body);
          } else {
            allItems.forEach(function (other) {
              if (other !== details && other.open) {
                var otherBody = other.querySelector('.s-compliance__item-body');
                if (otherBody) animateClose(other, otherBody);
              }
            });
            animateOpen(details, body);
          }
        });
      });
    }

    document.querySelectorAll('.s-compliance').forEach(initCompliance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING = 'ease';

    function animateOpen(details, body) {
      details.setAttribute('open', '');
      var target = body.scrollHeight + 'px';
      body.animate(
        [{ height: '0px', overflow: 'hidden' }, { height: target, overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
    }

    function animateClose(details, body) {
      var current = body.offsetHeight + 'px';
      var anim = body.animate(
        [{ height: current, overflow: 'hidden' }, { height: '0px', overflow: 'hidden' }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = function () {
        details.removeAttribute('open');
      };
    }

    function initFaq(section) {
      var allItems = Array.from(section.querySelectorAll('.s-faq__item'));

      allItems.forEach(function (details) {
        var summary = details.querySelector('.s-faq__item-summary');
        var body = details.querySelector('.s-faq__item-body');
        if (!summary || !body) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.open) {
            animateClose(details, body);
          } else {
            allItems.forEach(function (other) {
              if (other !== details && other.open) {
                var otherBody = other.querySelector('.s-faq__item-body');
                if (otherBody) animateClose(other, otherBody);
              }
            });
            animateOpen(details, body);
          }
        });
      });
    }

    document.querySelectorAll('.s-faq').forEach(initFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING   = 'ease';

    function getDescs(card) {
      return Array.from(card.querySelectorAll('.s-ingredients__benefit-desc'));
    }

    function openDescs(card, btn) {
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('.s-ingredients__expand-label').textContent = 'Show less';
      getDescs(card).forEach(function (desc) {
        var target = desc.scrollHeight + 'px';
        desc.animate(
          [{ height: '0px' }, { height: target }],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        ).onfinish = function () { desc.style.height = 'auto'; };
      });
    }

    function closeDescs(card, btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('.s-ingredients__expand-label').textContent = 'Show more';
      getDescs(card).forEach(function (desc) {
        desc.style.height = desc.scrollHeight + 'px';
        desc.animate(
          [{ height: desc.style.height }, { height: '0px' }],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        ).onfinish = function () { desc.style.height = '0'; };
      });
    }

    document.querySelectorAll('.s-ingredients').forEach(function (section) {
      var cards = Array.from(section.querySelectorAll('.s-ingredients__card'));

      cards.forEach(function (card) {
        var btn = card.querySelector('.s-ingredients__expand-btn');
        if (!btn) return;

        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';

          /* Close any other open card */
          cards.forEach(function (other) {
            var otherBtn = other.querySelector('.s-ingredients__expand-btn');
            if (otherBtn && otherBtn !== btn && otherBtn.getAttribute('aria-expanded') === 'true') {
              closeDescs(other, otherBtn);
            }
          });

          if (isOpen) { closeDescs(card, btn); } else { openDescs(card, btn); }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
